import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import {StickyTable, Row, Cell} from 'react-sticky-table';
import Tooltip from '@material-ui/core/Tooltip';
import { compose } from 'underscore';
import Button from '@material-ui/core/Button';
import { withTranslation } from 'react-i18next';
import { api_host, api_auth } from '../../../../../common/globals/constants';
import LightStatus from './LightStatus';
import { reportFetchError } from '../../../../../observability/rum';
class ObjectiveCell extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            objective: this.props.objectivesList,
            nodesIdList: this.props.nodesIdList,
            isLoading: true,
            loadError: false
        }
    }
    componentDidMount() {
        this.getDataFromAPI();
    } 
    getDataFromAPI = (objectiveId) => {
        
        const {objective, nodesIdList} = this.state
        let token = sessionStorage.getItem('key')
        let user = sessionStorage.getItem('user')
        let lightsPeriod = parseInt(sessionStorage.getItem('period_semaphore'))
        var objectiveName = objective.nombre
        var monitors = objective.Monitores
        var steps = objective.Pasos
        var interval = objective.intervalo
        var critic_step = objective.paso_critico
        Promise.all([
            fetch(api_host+`/reporte/online/indicadores/getUltimoEstadoObjetivo/?user=${user}&objetivoId=${objective.objetivo_id}&objectiveName=${objectiveName}&lightsPeriod=${lightsPeriod}&token=${token}&key=07374CEAC2EAEF2EB3441BA0C433F9834E6CF6E2&timestamp=${new Date().getTime()}`)
        ])
        .then(([res1]) => {
            return Promise.all([res1.json()])
        })
        .then(([res1]) => {
            //.then(response => response.json())
            //.then(myJson => { 
                let cell = []
                Object(nodesIdList).map((node, orden)=>{
                    var ok = false
                    var cellData = {}
                    Object(res1.Objetivo.Nodo).map((nodeStatus, orden)=>{
                        if (node == nodeStatus.nodo_id && !ok){
                            var colorEvent = '#41B900'  
                            var icon = <LightStatus status="success" />
                            var nameEvent = 'Ok' 
                            var descriptionEvent = '' 
                            cellData['objective'] = objective.objetivo_id
                            cellData['interval'] = interval
                            cellData['node'] =  nodeStatus
                            cellData['monitors'] = monitors
                            cellData['status'] = nodeStatus.Estado.nombre
                            cellData['code'] = nodeStatus.Estado.id
                            cellData['critic_step'] = critic_step
                            if (nodeStatus.Estado.id == 1){
                                icon = <LightStatus status="success" />
                                nameEvent = nodeStatus.Estado.nombre
                                descriptionEvent = 'El objetivo actualmente esta uptime y sin eventos downtime durante todo en el período.'
                            } else if (nodeStatus.Estado.id == 2) {
                                icon = <LightStatus status="error" />
                                nameEvent = nodeStatus.Estado.nombre
                                colorEvent = '#C2272D'
                                descriptionEvent = 'El objetivo actualmente esta en downtime.'
                            } else if (nodeStatus.Estado.id == 3) {
                                icon = <LightStatus status="warning" />
                                nameEvent = nodeStatus.Estado.nombre
                                colorEvent = '#ebeb34'
                                descriptionEvent = 'El objetivo actualmente esta uptime pero con eventos downtime durante parte del período.'
                            } else if (nodeStatus.Estado.id == 4) {
                                icon = <LightStatus status="none" />
                                nameEvent = nodeStatus.Estado.nombre
                                colorEvent = ' #A9A9A9'
                                descriptionEvent = 'No se ha recibido nueva informaci&oacute;n del objetivo desde el ISP.'
                            } else if (nodeStatus.Estado.id == 5) {
                                icon = <LightStatus status="none" />
                                nameEvent = nodeStatus.Estado.nombre
                                colorEvent = ' #A9A9A9'
                                descriptionEvent = 'El objetivo actualmente no se esta monitoreando desde el ISP.'
                            } else if (nodeStatus.Estado.id == 6) {
                                icon = <LightStatus status="none" />
                                nameEvent = nodeStatus.Estado.nombre
                                colorEvent = ' #A9A9A9'
                                descriptionEvent = 'Evento Cliente.'
                            }
                            cellData['descriptionEvent'] = descriptionEvent
                            cellData['nameEvent'] = nameEvent
                            cellData['icon'] = icon
                            cellData['color'] = colorEvent
                            var duration = nodeStatus.Estado.duracion
                            if (duration.includes('days')){
                                duration = duration.replace('days','día(s)')
                            } else if (duration.includes('day')){
                                duration = duration.replace('day','día')
                            }
                            cellData['duration'] = duration
                            cell.push(cellData)
                            ok = true
                        } 
                    })
                    if (!ok){
                        cellData['status'] = ""
                        cellData['code'] = ""
                        cellData['duration'] = ""
                        cellData['color'] = ""
                        cellData['icon'] = ""
                        cellData['step'] = ""
                        cell.push(cellData)
                    }
                })
                this.setState({cells: cell, isLoading: false});
            })
        .catch((error) => {
            reportFetchError('LightsObjectiveCell', error)
            let cell = Object(nodesIdList).map(() => ({status: "", code: "", duration: "", color: "", icon: "", step: ""}))
            this.setState({cells: cell, isLoading: false, loadError: true});
        })
        
    }

    processData = (externalData) => {
    }

    handleClose = event => {

        /*if (reason === 'clickaway') {
          	return;
        }
        this.setState({
            open: false 
        })*/
        this.props.onClose()
    };
    onCellClick = (event) => {
        const {cells, key} = this.state
        let lightsPeriod = parseInt(sessionStorage.getItem('period_semaphore'))
        var endDate = new Date()
        endDate = endDate.getTime() 
        var startDate = endDate - lightsPeriod*1000
        let point = []
        point['x'] = startDate
        point['x2'] = endDate
        point['y'] = cells[event.currentTarget.id].node.nodo_nombre
        this.props.onCellClick(point, cells[event.currentTarget.id].monitors, cells[event.currentTarget.id].objective, cells[event.currentTarget.id].interval, cells[event.currentTarget.id].critic_step)
       
    }

    render() {
        const {isLoading, loadError, cells, objective} = this.state
        const t = (this.props && this.props.t) ? this.props.t : (s => s)
        if (!isLoading)  {
            return  <Row style={{maxHeight:'50px'}}>
                        <Cell 
                            style={{
                                width: '360px', 
                                padding: '0px', 
                                maxWidth: '360px', 
                                minWidth: '360px', 
                                backgroundColor: '#bebebe', 
                                color: 'white', 
                                left: 0, 
                                position: "sticky", 
                                zIndex: 2, 
                                borderBottom: "2px solid #e4dede", 
                                borderRight: "2px solid #e4dede"
                            }}
                        >
                            <Tooltip 
                                title={
                                    <div>
                                        <Typography variant="h5" style={{ color: 'white' }}>{objective.nombre}</Typography>
                                    </div>
                                }
                            >
                                <Button 
                                    id={objective.objetivo_id} 
                                    value={objective.nombre} 
                                    onClick={this.props.handleOpenObjectiveModal}
                                    style={{
                                        width: '100%',
                                        justifyContent: 'flex-start', // Alinea el contenido a la izquierda
                                        textAlign: 'left',            // Alinea el texto a la izquierda
                                        textTransform: 'none',        // Opcional: evita que MUI fuerce el texto a MAYÚSCULAS
                                        padding: '6px 16px'
                                    }}
                                >
                                    <Typography 
                                        variant="h6" 
                                        style={{
                                            color: 'black',
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis', // Muestra "..." si sobrepasa el espacio
                                            width: '100%'
                                        }}
                                    >
                                        {objective.nombre}
                                    </Typography>
                                </Button>
                            </Tooltip>
                            {loadError ?
                                <Typography variant="caption" style={{color:'black', display:'block', paddingLeft:'16px', textAlign:'left'}}>{t('text.load-error')}</Typography>
                            : null}
                        </Cell>
                        {Object(cells).map((cell,i)=>(
                            cell.icon != "" ? <Tooltip 
                                title={<div>
                                    <Typography variant="h4" style={{color:'white'}}>{cell.nameEvent}</Typography>
                                    <Typography variant="h6" style={{color:'white'}}>{cell.descriptionEvent}</Typography>
                                    <Typography variant="h6" style={{color:'white'}}>{t('traffic-light.popover.text.duration')+": "+cell.duration}</Typography>
                                    </div>} 
                                placement="bottom" arrow>
                                <Cell align="center" style={{width:'80px', maxWidth:'80px', minWidth:'80px', borderBottom: "2px solid #d4d4d4", borderRight: "2px solid #e4dede", backgroundColor: '#e9e9e9', textAlign: 'center'}}>
                                    <Typography style={{height:"20px"}}>
                                        <Button id ={i} value={'hola'} onClick={this.onCellClick}>
                                            {cell.icon}
                                        </Button>
                                    </Typography>
                                </Cell>
                            </Tooltip>
                            : <Cell style={{maxWidth:'80px', minWidth:'80px', borderBottom: "2px solid #d4d4d4", borderRight: "2px solid #e4dede", backgroundColor: '#e9e9e9'}}>
                              </Cell>
                        ))}
                    </Row>    
                          
            
        } else {
            return <div>      
                    <Typography
                        
                        variant="h5">
                        <CircularProgress
                            variant="indeterminate"      
                            size={24}
                            thickness={4}                            
                        />
                        {t('text.loading')}
                    </Typography>        
                </div>     
        }
    }
}
export default compose(withTranslation())(ObjectiveCell);